'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CommonProtocolClient = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonProtocolClient = exports.CommonProtocolClient = function () {
	function CommonProtocolClient(_ref) {
		var XMLHttpRequest = _ref.XMLHttpRequest,
		    endpointUrl = _ref.endpointUrl,
		    timeout = _ref.timeout;
		(0, _classCallCheck3.default)(this, CommonProtocolClient);

		this.XMLHttpRequest = XMLHttpRequest;
		this.endpointUrl = endpointUrl;
		this.timeout = timeout || 0;
	}

	(0, _createClass3.default)(CommonProtocolClient, [{
		key: 'doRequest',
		value: function doRequest(resource, request) {
			var _this = this;

			return new _promise2.default(function (resolve, reject) {
				var xhr = new _this.XMLHttpRequest();
				xhr.ontimeout = function () {
					return reject({
						code: 'timeout',
						description: 'request timed out'
					});
				};
				xhr.onerror = function () {
					return reject({
						code: 'network_down',
						description: 'network is down'
					});
				};
				xhr.onload = function () {
					try {
						var response = JSON.parse(xhr.responseText);
						if (response.error) {
							reject(response.error);
						} else {
							resolve(response.value);
						}
					} catch (e) {
						reject({
							code: 'protocol',
							description: 'unexpected response format'
						});
					}
				};

				xhr.open('POST', _this.endpointUrl + resource, true);
				xhr.timeout = _this.timeout;
				xhr.setRequestHeader('Content-Type', 'application/json');
				xhr.send((0, _stringify2.default)(request));
			});
		}
	}]);
	return CommonProtocolClient;
}();